import { Box, Button, Typography } from "@mui/material";
import { RightArrow } from "../../utils/icon/Landing-Page/Icon";
import GantChart from '../../assets/landing_page/Images/gantt Chart.png'
import { Link as RouterLink } from "react-router-dom";


export const SecondPage = () => {
    return (
        <Box sx={{ background: '#F3F5F7', height: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', width: '80%', py: 3 }}>
                <Typography sx={{ fontSize: '20px', color: '#0057D5', fontWeight: '700', py: 4 }}>Live Demo</Typography>
                <Typography sx={{ fontSize: '40px', color: '#040815', fontWeight: '700', py: 2 }}>Experience Our Platform in Action</Typography>
                <Typography sx={{ fontSize: '20px', color: '#474747', fontWeight: '500', py: 2 }}>See how our powerful tools can transform your project management. <br />
                    Explore the features and benefits in a live demo now.</Typography>
                    <RouterLink to={"/Reg"}>
                <Button sx={{ color: '#fff', background: '#FF2800', height: '40px', my: 2, mb: 4, borderRadius: '40px', mx: '10px', textTransform: 'capitalize', '&:hover': { background: '#FF280099' }, px: 3 }}><Typography sx={{ mr: 2 }}>Try For Free</Typography><RightArrow /></Button>
                </RouterLink>
                <Box sx={{ background: '#fff', height: '100%', px: 6, py: 12, my: 2, borderRadius: '16px', py: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={GantChart} alt="" style={{ height: 'auto', width: '100%', my: 2, border: '1px solid #CECECE' }} />
                </Box>
            </Box>
        </Box>
    );
}